import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DashboardService } from '../../dashboard';
import * as moment from 'moment';
import { ErrorHandlerService } from '../../services';
import { ConfirmationService } from 'primeng/primeng';
// import {EditorModule,SharedModule} from 'primeng/primeng';
var ViewTopicComponent = /** @class */ (function () {
    function ViewTopicComponent(dashboardService, route, errorHandlerService, confirmationService, router) {
        this.dashboardService = dashboardService;
        this.route = route;
        this.errorHandlerService = errorHandlerService;
        this.confirmationService = confirmationService;
        this.router = router;
        this.less = true;
        this.more = false;
        this.query = '';
        this.userId = '';
        this.topicDetail = {};
        this.topicTO = { topicName: '', userDetailsSummaryTO: {}, topicPermissionTO: {} };
        this.commentData = { userDetailsSummaryTO: {} };
        this.innerCommentData = { userReplyingToComment: {} };
        this.topicCmt = [];
        this.user = {};
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        this.PR = window["PR"];
        this.facebookShareUrl = "";
        this.facebookShareUrl = process.env.API_URL + "/generateFacebookPreviewForTopic.do/";
    }
    ViewTopicComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    ViewTopicComponent.prototype.morecontent = function () {
        this.more = true;
        this.less = false;
    };
    ViewTopicComponent.prototype.lesscontent = function () {
        this.more = false;
        this.less = true;
    };
    ViewTopicComponent.prototype.joinTopic = function (topicId) {
        var _this = this;
        this.dashboardService.joinTopic(topicId).subscribe(function (data) {
            console.log(data);
            _this.dashboardService.userSummary1().subscribe(function (data) { _this.userId = data.userDetailsId; }, function (error) {
                _this.handleError(error);
            });
            _this.route.queryParams.subscribe(function (params) {
                _this.query = params['topic'] || 0;
                console.log(_this.query);
                if (_this.query != '0') {
                    _this.dashboardService.getTopic(_this.query).subscribe(function (data) {
                        console.log(data);
                        _this.topicDetail = data;
                        _this.topicCmt = data.topicTO.topicComments;
                        _this.topicTO = data.topicTO;
                    }, function (error) {
                        _this.handleError(error);
                    });
                }
            });
            // if(data == 'SUBSCRIBE'){
            //   this.topicDetail.actionToPerformOnTopic = 'SUBSCRIBE';
            // }else if(data == 'REQUEST_TO_JOIN'){
            //   this.topicDetail.actionToPerformOnTopic = 'REQUEST_TO_JOIN';
            // }
        }, function (error) {
            _this.handleError(error);
        });
    };
    ViewTopicComponent.prototype.reportSpam = function (type, id) {
        var _this = this;
        this.confirmationService.confirm({
            message: "<b>Report Spam and Block</b>",
            header: 'Confirmation',
            icon: 'fa fa-question-circle',
            accept: function () {
                _this.showSpinner = true;
                _this.dashboardService.topicSpam(type, id).subscribe(function (data) {
                    _this.showSpinner = false;
                    console.log(data);
                }, function (error) {
                    _this.showSpinner = false;
                    _this.handleError(error);
                });
            },
            reject: function () {
                _this.showSpinner = false;
                console.log("User cancelled registration");
            }
        });
    };
    ViewTopicComponent.prototype.closeTopic = function () {
        var _this = this;
        this.dashboardService.closeTopic(this.query).subscribe(function (data) {
            console.log(data);
            _this.dashboardService.userSummary1().subscribe(function (data) { _this.userId = data.userDetailsId; }, function (error) {
                _this.handleError(error);
            });
            _this.route.queryParams.subscribe(function (params) {
                _this.query = params['topic'] || 0;
                console.log(_this.query);
                if (_this.query != '0') {
                    _this.dashboardService.getTopic(_this.query).subscribe(function (data) {
                        console.log(data);
                        _this.topicDetail = data;
                        _this.topicCmt = data.topicTO.topicComments;
                        _this.topicTO = data.topicTO;
                    }, function (error) {
                        _this.handleError(error);
                    });
                }
            });
        }, function (error) {
            _this.handleError(error);
        });
    };
    ViewTopicComponent.prototype.redirectClick = function (url) {
        window.open(url, "Website");
        return false;
    };
    ViewTopicComponent.prototype.leaveTopic = function () {
        var _this = this;
        this.dashboardService.leaveTopic(this.query).subscribe(function (data) {
            console.log(data);
            _this.router.navigate(['dashboard/topiclist']);
            // this.dashboardService.userSummary1().subscribe(
            // data => {this.userId = data.userDetailsId;},
            // error => {console.log(error);});
            // this.route.queryParams.subscribe(params => {
            // 	this.query = params['topic'] || 0;
            //   console.log(this.query);
            //   if(this.query != '0'){
            //     this.dashboardService.getTopic(this.query).subscribe(
            //       data => { console.log(data);
            //        this.topicDetail = data; this.topicCmt = data.topicTO.topicComments; this.topicTO = data.topicTO;
            //       },
            //       error => {}
            //     );
            //   }
            // });
        }, function (error) {
            _this.handleError(error);
        });
    };
    ViewTopicComponent.prototype.addComment = function (id) {
        var _this = this;
        this.commentData.topicDetailId = id;
        this.commentData.userDetailsSummaryTO.userDetailsId = this.userId;
        this.commentData.formattedDate = moment(new Date()).format('MM/DD/YYYY');
        this.dashboardService.addComment(this.commentData).subscribe(function (data) {
            console.log(data);
            _this.commentData.topicComment = "";
            // this.topicDetail = data;
            //  this.topicCmt = data.topicTO.topicComments; this.topicTO = data.topicTO;
            // this.dashboardService.userSummary1().subscribe(
            //   data => {this.userId = data.userDetailsId;},
            //   error => {console.log(error);}
            // );
            _this.route.queryParams.subscribe(function (params) {
                _this.query = params['topic'] || 0;
                console.log(_this.query);
                if (_this.query != '0') {
                    _this.dashboardService.getTopic(_this.query).subscribe(function (data) {
                        console.log(data);
                        _this.topicDetail = data;
                        _this.topicCmt = data.topicTO.topicComments;
                        _this.topicTO = data.topicTO;
                    }, function (error) {
                        _this.handleError(error);
                    });
                }
            });
        }, function (error) {
            _this.handleError(error);
        });
    };
    ViewTopicComponent.prototype.addinnerComment = function (topicid, commentid) {
        var _this = this;
        this.innerCommentData.topicDetailId = topicid;
        this.innerCommentData.topicCommentId = commentid;
        this.innerCommentData.formattedDate = moment(new Date()).format('MM/DD/YYYY');
        this.innerCommentData.userReplyingToComment.userDetailsId = this.userId;
        console.log(this.innerCommentData);
        this.dashboardService.addInnerComment(this.innerCommentData).subscribe(function (data) {
            console.log(data);
            _this.innerCommentData.topicCommentReply = "";
            // this.dashboardService.userSummary1().subscribe(
            //   data => {this.userId = data.userDetailsId;},
            //   error => {console.log(error);}
            // );
            // this.userId = data.userDetailsSummaryTO.userDetailsId;
            _this.route.queryParams.subscribe(function (params) {
                _this.query = params['topic'] || 0;
                console.log(_this.query);
                if (_this.query != '0') {
                    _this.dashboardService.getTopic(_this.query).subscribe(function (data) {
                        console.log(data);
                        _this.topicDetail = data;
                        _this.topicCmt = data.topicTO.topicComments;
                        _this.topicTO = data.topicTO;
                    }, function (error) { _this.handleError(error); });
                }
            });
            // this.topicDetail = data;
            _this.topicCmt = data.topicComments;
            // this.topicTO = data.topicTO;
        }, function (error) {
            _this.handleError(error);
        });
    };
    ViewTopicComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.topicDetail = { topicTo: { topicName: {} } };
        this.dashboardService.userSummary1().subscribe(function (data) { _this.userId = data.userDetailsId; _this.user = data; console.log(_this.user); }, function (error) {
            _this.handleError(error);
        });
        this.route.queryParams.subscribe(function (params) {
            _this.query = params['topic'] || 0;
            _this.facebookShareUrl = _this.facebookShareUrl + _this.query;
            console.log(_this.query);
            if (_this.query != '0') {
                _this.dashboardService.getTopic(_this.query).subscribe(function (data) {
                    console.log(data);
                    _this.topicDetail = data;
                    _this.topicCmt = data.topicTO.topicComments;
                    _this.topicTO = data.topicTO;
                }, function (error) {
                    _this.handleError(error);
                });
            }
        });
    };
    ViewTopicComponent.prototype.likeTopic = function (topicId) {
        var _this = this;
        this.dashboardService.likeTopic(topicId).subscribe(function (data) {
            console.log(data);
            _this.topicTO.noOfLikes = data.noOfLikes;
            _this.topicDetail.isTopicAlreadyLikedByUser = true;
        }, function (error) {
            _this.handleError(error);
        });
    };
    ViewTopicComponent.prototype.unlikeTopic = function (topicId) {
        var _this = this;
        this.dashboardService.unlikeTopic(topicId).subscribe(function (data) {
            console.log(data);
            _this.topicTO.noOfLikes = data.noOfLikes;
            _this.topicDetail.isTopicAlreadyLikedByUser = false;
        }, function (error) {
            _this.handleError(error);
        });
    };
    ViewTopicComponent.prototype.ngAfterViewChecked = function () {
        console.log('ngAfterViewChecked');
        this.PR.prettyPrint();
    };
    ViewTopicComponent.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return ViewTopicComponent;
}());
export { ViewTopicComponent };
//# sourceMappingURL=viewtopic.component.js.map